import { Col, Row } from "antd-v4";

export default function Footer() {
  return (
    <Col span={24} className="hp-py-32">
      <p className="hp-mb-8 hp-p1-body hp-text-color-black-60">
        Leedpulse • Transformez vos contacts en chiffre d'affaires grâce à l'IA
      </p>

      <Row align="middle" justify="center" gutter={16}>
        <Col>
          <a
            className="hp-p1-body hp-text-color-black-80 hp-hover-text-color-primary-1"
            target="_blank"
            rel="noreferrer"
            href="https://www.leedpulse.com/mentions-legales"
          >
            Mentions légales
          </a>
        </Col>

        <Col>
          <a
            className="hp-p1-body hp-text-color-black-80 hp-hover-text-color-primary-1"
            target="_blank"
            rel="noreferrer"
            href="https://www.leedpulse.com/politique-de-confidentialite"
          >
            Politique de confidentialité
          </a>
        </Col>

        <Col>
          <a
            className="hp-p1-body hp-text-color-black-80 hp-hover-text-color-primary-1"
            target="_blank"
            rel="noreferrer"
            href="https://www.leedpulse.com/conditions-generales-dutilisation"
          >
            Conditions générales d'utilisation
          </a>
        </Col>
      </Row>
    </Col>
  );
}
